/**
 * IMPORTS
 */
import { useEffect, useState } from "react";

/**
 * Prévia de uma imagem escolhida antes de enviar. Lê como data URL (arquivo local):
 * não há object URL para liberar.
 */
function MiniaturaArquivoSelecionado({ arquivo }: { arquivo: File }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    const leitor = new FileReader();
    leitor.onload = () => {
      if (typeof leitor.result === "string") setSrc(leitor.result);
    };
    leitor.readAsDataURL(arquivo);
    return () => leitor.abort();
  }, [arquivo]);

  if (!src)
    return <span className="size-8 shrink-0 animate-pulse rounded bg-gray-200" aria-hidden />;

  return <img src={src} alt="" className="size-8 shrink-0 rounded object-cover" />;
}

/**
 * EXPORTS
 */
export { MiniaturaArquivoSelecionado };
